module.exports = __webpack_public_path__ + "static/img/24game.65e7f22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/secondToolList/24game.png
// module id = pN8r
// module chunks = 3